/**
 * Forgot Password Replacer View
 */

// DOES NOT SUPPORT IN CORE

define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');
    const core = require('core');
    const utils = require('utils');
    const _ = require('underscore');
    const config = require('config');
    const pas = require('util/pas.util');
    const Form = require('class/form.class');
    const BaseView = require('common/base.view');
    const serverUtil = require('util/server.util');
    const dispatcher = require('bundle').dispatcher;
    const dateMixin = require('portlets/registration/mixins/date.mixin');
    const RecoveryTypes = require('replacers/parx-theme/forgotpassword/recovery-types');
    const userValidationConfig = require('modules/user/user.validation.config');
    const ForgotPasswordModel = require('replacers/parx-theme/forgotpassword/forgotpassword.model');

    module.exports = BaseView.extend({

        mixins: [dateMixin],
        accessRules: {
            allow: ['guest']
        },

        events: function() {
            return _.extend({
                'change #month': 'setDays',
                'change #year': 'setDays',
                'tap .fn-cancel': 'handleCancelClick',
                'submit .fn-forgotpassword-form': 'handleForgotPasswordSubmit',
                'submit .fn-forgotpassword-question-form': 'handleVerificationAnswerSubmit',
                'submit .fn-forgotpassword-set-new-password-form': 'handleNewPasswordSubmit',
                'submit .fn-forgotpassword-set-new-password-form-by-token': 'handleNewPasswordByTokenSubmit',
            }, BaseView.prototype.events);
        },

        initialize: function() {
            this.model = new ForgotPasswordModel();

            const url = new URL(window.location);
            const fpActionToken = url.searchParams.get('fpActionToken');
            if (fpActionToken) {
                this.model.set('fpActionToken', fpActionToken);

                window.Playtech.API.common.replace(url.pathname, undefined, { removeParams: ['fpActionToken'] });

                this._forgotPassByToken();
            }

            this.isEmailOnly = config.get('detailsRecovery')?.useEmailOnly;
            this.isUseQuestion = config.get('detailsRecovery')?.isRequiredVerificationEnable;

        },

        render: function() {
            if (this.model.get('fpActionToken')) {
                this.$el.html(this.tmpl('forgotpassword.set-new-password', { byToken: true }));
                this.form = new Form(this.$('.fn-forgotpassword-set-new-password-form-by-token'), {
                    validationConfig: userValidationConfig()
                });
                this.form.showLoading();
            } else {
                this.$el.html(this.tmpl('forgotpassword', this.getTmplData()));
                this.form = new Form(this.$('.fn-forgotpassword-form'), this.getFormData());
            }

            return this;
        },

        getTmplData: function() {
            return {
                hideUsername: this.isEmailOnly,
                hideCancel: new URLSearchParams(location.search).get('noPageAsPopup') === '1'
            };
        },

        getFormData: function() {
            return {
                validationConfig: userValidationConfig(),
                isBirthdateRequired: true
            };
        },

        setDays: function() {
            utils.checkBirthdate(this.$('#day'), this.$('#month'), this.$('#year'));
        },

        /**
         * Sends initial user data
         * @param e
         * @returns {*}
         */
        handleForgotPasswordSubmit: function(e) {
            e.preventDefault();

            return this.validateAndSendForm({
                requestMethod: this.model.forgotPasswordAction.bind(this.model),
                onSuccess: this.successRequest.bind(this)
            });
        },

        /**
         * Helper method for sending form data
         * @param requestOptions
         * @returns {*}
         */
        validateAndSendForm: function(requestOptions) {
            var options = _.defaults(requestOptions, {
                requestMethod: _.noop,
                onSuccess: _.noop,
                onError: this.errorRequest.bind(this)
            });

            return this.form.validate()
                .done(function(data, form) {
                    form.showLoading();

                    options.requestMethod(data)
                        .always(form.hideLoading.bind(form))
                        .done(options.onSuccess)
                        .fail(options.onError);
                });
        },

        errorRequest: function(response) {
            const { errorCode } = response.data;
            const isUseOtherKey = this.isUseQuestion && this.isEmailOnly && errorCode === 107;
            let prefix = 'playtech.mobile.system.forgotPass.error.';

            if (isUseOtherKey) {
                prefix = prefix + 'questionanswer.';
            }
            const content = serverUtil.getErrorMessage(response, { prefix });

            this.form.showErrorMessage({ content });
        },

        successRequest: function(responseData) {
            const enableSmsNotifications = config.get('detailsRecovery')?.enableSmsNotifications;

            switch (this.model.get('recoveryType')) {
                case RecoveryTypes.BY_EMAIL: {
                    const content = enableSmsNotifications
                        ? this.translate('playtech.mobile.system.forgotPass.success.withSMS')
                        : this.translate('playtech.mobile.system.forgotPass.success');

                    this.form.clear();
                    this.showInfo({ content });
                    break;
                }
                case RecoveryTypes.BY_VERIFICATION_QUESTION: {
                    const { userErrors } = responseData;

                    if (userErrors && userErrors.length > 0) {
                        const { templateId, message = '' } = userErrors[0];

                        this.form.clear();
                        this.showInfo({
                            content: i18n.tExt(
                                `playtech.mobile.system.forgotPass.${templateId}${enableSmsNotifications ? '.withSMS' : ''}`,
                                message
                            )
                        });
                        break;
                    }

                    this.renderVerificationQuestionForm(responseData.verificationQuestion);
                    break;
                }
                default:
                    break;
            }
        },

        renderVerificationQuestionForm: function(verificationQuestion) {
            this.form.undelegateEvents();
            this.$el.html(this.tmpl('forgotpassword.verification-question', {
                verificationQuestion: verificationQuestion
            }));

            this.form = new Form(this.$('.fn-forgotpassword-question-form'), {
                validationConfig: userValidationConfig()
            });
        },

        handleVerificationAnswerSubmit: function(e) {
            e.preventDefault();

            return this.validateAndSendForm({
                requestMethod: this.model.sendVerificationAnswer.bind(this.model),
                onSuccess: this.renderNewPasswordForm.bind(this)
            });
        },

        renderNewPasswordForm: function(params) {
            this.form.undelegateEvents();
            this.$el.html(this.tmpl('forgotpassword.set-new-password', params));
            var $form = params && params.byToken ?
                this.$('.fn-forgotpassword-set-new-password-form-by-token') :
                this.$('.fn-forgotpassword-set-new-password-form');

            this.form = new Form($form, {
                validationConfig: userValidationConfig()
            });
        },

        handleNewPasswordSubmit: function(e) {
            e.preventDefault();

            return this.validateAndSendForm({
                requestMethod: this.model.sendNewPassword.bind(this.model),
                onSuccess: this.passwordSuccessRequest.bind(this)
            });
        },

        passwordSuccessRequest: function(response) {
            if (this.isTwoFactorAuthError(response)) {
                this.showTwoFactorAuthPopup(response);

                return;
            }

            this.form.clear();
            this.showInfo({
                content: this.translate('playtech.mobile.system.forgotPass.passwordSuccessfullyChanged'),
                onClose: () => {
                    core.navigate('/');
                    core.request('auth:action:quietLogout');
                    core.trigger('app:action:loginPopup');
                }
            });
        },

        _forgotPassByToken: function() {
            this.model.forgotPassByTokenRequest()
                .always(() => this.form.hideLoading())
                .fail(pasResponse => this.forgotPassTokenError(pasResponse));
        },

        forgotPassTokenError: function(response) {
            const { errorText, errorMessage, errorCode, playerMessage } = response.data;
            const tkPrefix = 'playtech.mobile.system.forgotPassToken.error.';

            this.form.showErrorMessage({
                translation: tkPrefix + errorCode,
                content: playerMessage || errorMessage || errorText
            });
        },

        handleNewPasswordByTokenSubmit: function(e) {
            e.preventDefault();

            return this.validateAndSendForm({
                requestMethod: pas.changePassword.bind(pas),
                onSuccess: this.passwordSuccessRequest.bind(this)
            });
        },

        isTwoFactorAuthError: function(error) {
            const data = error?.data || error?.response?.data || {};

            return data.sessionValidationData?.SessionValidationBy2FAData || data.errorCode === 303;
        },

        showTwoFactorAuthPopup: function(response) {
            window.Playtech.API.popup.showPopup('twoFactorAuthentication', {
                onSuccess: this.onTwoFactorAuthSuccess.bind(this),
                resendHandler: this.resendTwoFactorAuthPin.bind(this),
                title: serverUtil.getMessageFromActions(response)
            });
        },

        onTwoFactorAuthSuccess: function() {
            const { password } = this.form.data();

            this.form.showLoading();

            return pas.changePassword({ password })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.passwordSuccessRequest.bind(this))
                .fail(this.errorRequest.bind(this));
        },

        /**
         * Needed for request pin code within Two Factor Auth popup
         */
        resendTwoFactorAuthPin: function() {
            const { password } = this.form.data();

            return pas.changePassword({ password });
        },

        handleCancelClick: function() {
            if (dispatcher) {
                dispatcher.dispatch('pageInPopup:closed');
            }
        }
    }, {
        nameOfReplacers: [
            'FORGOT_PASSWORD'
        ]
    });
});
